import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './locales/en/translation.json';
import frTranslation from './locales/fr/translation.json';

/**
 * Extract language code from locale string.
 * e.g., "fr-CA" -> "fr", "en-US" -> "en"
 */
export function extractLanguageFromLocale(locale: string | undefined | null): string {
  if (!locale) return 'en';
  const lang = locale.split('-')[0].toLowerCase();
  // Only return supported languages, default to 'en'
  return ['en', 'fr'].includes(lang) ? lang : 'en';
}

/**
 * Get initial language from localStorage (fallback for before profile loads).
 * This provides a better UX for returning users before auth completes.
 */
function getInitialLanguage(): string {
  try {
    const stored = localStorage.getItem('i18nextLng');
    if (stored && ['en', 'fr'].includes(stored)) {
      return stored;
    }
  } catch {
    // localStorage not available
  }
  return 'en';
}

// Initialize i18next
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      fr: {
        translation: frTranslation,
      },
    },
    lng: getInitialLanguage(), // Use localStorage as initial fallback, will be synced with profile
    fallbackLng: 'en',
    debug: import.meta.env.DEV, // Enable debug in development only
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
